import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { ShieldAlert, ArrowLeft } from "lucide-react";

const RoleGuard = ({ allowedRoles }) => {
  const { user } = useAuthStore();
  const navigate = useNavigate();

  if (!allowedRoles.includes(user?.role)) {
    return (
      <div className="flex items-center justify-center h-[70vh] p-6">
        <div className="card bg-white border border-slate-200 p-12 text-center max-w-lg mx-auto">
          <ShieldAlert className="w-16 h-16 text-red-500 mx-auto mb-6 opacity-60" />
          <h1 className="text-xl font-bold text-slate-900">
            Access Restricted
          </h1>
          <p className="text-slate-500 mt-2 mb-8">
            Your role (<strong>{user?.role?.replace("_", " ")}</strong>) does
            not have permission to view this page.
          </p>
          <button onClick={() => navigate(-1)} className="btn btn-secondary">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default RoleGuard;
